import React, { useState } from 'react'

import Modal from 'react-modal'

import '@src/components/modals/ErrorPopUpModal/index.css'
import { createContextLogger } from '@src/utils/logger'

const modalLogger = createContextLogger('ErrorPopUpModal')

interface ErrorPopUpModalProps {
    isOpen: boolean
    title: string
    subtitle: string
    details: string
    onClose: () => void
}

const ErrorPopUpModal: React.FC<ErrorPopUpModalProps> = ({ isOpen, title, subtitle, details, onClose }) => {
    const [tooltipText, setTooltipText] = useState('Copy Error Details')

    const handleCopy = () => {
        // Check if navigator.clipboard is available
        if (window.navigator.clipboard) {
            window.navigator.clipboard
                .writeText(details)
                .then(() => {
                    showCopiedMessage()
                })
                .catch(() => {
                    modalLogger.warn('Browser does not support clipboard')
                })
        }
    }

    const showCopiedMessage = () => {
        setTooltipText(' Error Details Copied!')
        setTimeout(() => {
            setTooltipText('Copy  Error Details')
        }, 2000) // Reset after 2 seconds
    }

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            ariaHideApp={true}
            className={`error-popup-modal fixed left-1/2 top-1/2 flex w-[464px] max-w-[calc(50%-24px)] -translate-x-1/2 -translate-y-1/2 transition-all duration-500`}
            portalClassName='ErrorModalPortal'
            overlayClassName='ErrorModal__Overlay'
            style={{
                overlay: {
                    zIndex: 2147483646,
                    backgroundColor: 'rgba(0,0,0,.6)',
                },
            }}
            id='error-popup-modal'
        >
            <div className='rounded-2xl border border-mach-modal-border bg-mach-modal-background px-2 py-4'>
                <h2 className='text-center text-xl font-semibold text-red-800'>
                    {title}
                    <br />
                    {subtitle}
                </h2>
                <div className='text-center text-sm text-red-800'>
                    Please help our development team by sending us the error details.
                </div>
                <div className='items-center justify-center'>
                    <div
                        id='error-details'
                        // className='max-h-40 w-[464px] max-w-[calc(100%-24px)] overflow-auto rounded border border-gray-300 border-mach-modal-border p-2 text-sm text-red-600'
                        className='max-h-40 w-[464px] max-w-[calc(100%-24px)] overflow-auto rounded border border-gray-300 border-mach-modal-border p-2 text-sm text-red-600'
                    >
                        <pre>{details}</pre>
                    </div>
                </div>

                <div>
                    <div className='py-5'>
                        <button
                            className='w-full items-center justify-center rounded-md bg-red-800 px-4 py-2 text-white hover:bg-gray-300'
                            onClick={handleCopy}
                        >
                            {tooltipText}
                        </button>
                    </div>
                    <div>
                        <button
                            className='w-full items-center justify-center rounded-md bg-red-800 px-4 py-2 text-white hover:bg-gray-300'
                            onClick={onClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export const launchErrorPopUp = (() => {
    let setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
    let setTitle: React.Dispatch<React.SetStateAction<string>>
    let setSubTitle: React.Dispatch<React.SetStateAction<string>>
    let setDetails: React.Dispatch<React.SetStateAction<string>>

    const ErrorPopupWrapper = () => {
        const [isOpen, setOpen] = useState(false)
        const [title, setPopupTitle] = useState('')
        const [subtitle, setPopupSubTitle] = useState('')
        const [details, setPopupDetails] = useState('')

        setIsOpen = setOpen
        setTitle = setPopupTitle
        setSubTitle = setPopupSubTitle
        setDetails = setPopupDetails

        return (
            <ErrorPopUpModal
                isOpen={isOpen}
                title={title}
                subtitle={subtitle}
                details={details}
                onClose={() => setOpen(false)}
            />
        )
    }

    const launch = (title: string, subtitle: string, details: string) => {
        if (setIsOpen && setTitle && setSubTitle && setDetails) {
            setTitle(title)
            setDetails(details)
            setSubTitle(subtitle)
            setIsOpen(true)
        } else {
            modalLogger.error('Cannot launch Error modal.')
        }
    }

    return { launch, ErrorPopupWrapper }
})()

export default ErrorPopUpModal
